import React from 'react';
import { IconProps } from './type';

export const ICFavoriteExtension: React.FC<IconProps> = ({
    fill = 'none',
    stroke = '#4f4b5c',
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 800 800"
        >
            <path
                fill={fill}
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="66.667"
                d="M400 256.477c-66.668-156.48-300-139.813-300 60.187s300 366.672 300 366.672 300-166.672 300-366.672c0-200-233.332-216.668-300-60.187zm0 0"
            ></path>
        </svg>
    );
};
